export const VERSION = '5.2.20'
export const ACTIONS = {
    UPDATE: 'UPDATE',
    FORCE_UPDATE: 'FORCE_UPDATE',
    LOAD_JSON: 'LOAD_JSON',
    START_OVER: 'START_OVER',
    HISTORY: 'HISTORY',
    ZALESSKU: 'ZALESSKU',
  };
export const DEFAULT_STATE_VALUE = '-1'
export const ENGRAVING_TIMEOUT = 1000
export const INITIAL_STATE = {
  'version':VERSION,
  'showSticky':true,
  'active_view':1,
  'active_view4':1,
  'active_view5':1,
}
export const DEFAULT_ATTR_VALUE = {
  //'hmetc':'W',
  'rmetc':'W',
  'bmetc':'W',
  'rmet':'14',
  'bmet':'14',
  'dctw':'0.33',
  'ds':'R',
  'dq':'I',
  'band':'0',
  'ren':'1',
  'ben':'1',
  'head':'N',
  'sh':'STR'
}

export const SPECIAL_NOTE_SMALL = ''
//export const SPECIAL_NOTE_SMALL = "Order by Tuesday, January 30, 2024 for Valentine's Day delivery. This delivery date overrides regular processing times. "

//export const SPECIAL_NOTE_SMALL = "Order by Friday, April 26, 2024 for Mother's Day delivery. This delivery date overrides regular processing times. "
//export const SPECIAL_NOTE_SMALL ='Order by Wednesday, December 6, 2023 for Christmas delivery. This delivery date overrides regular processing times.'

export const SPECIAL_NOTE_SMALL1 = 'Need a gift by Christmas,  '
export const SPECIAL_NOTE_LINK =  "//www.kay.com/-lastmingifts/c/9000001002?q=*%3Afeatures%3AjewelrySearchType_string%3ARing%3AringStyle_string%3AEngagement+Ring%3AringStyle_string%3ABridal+Set%3AringStyle_string%3AWedding&text=&searchStore=&loadMore=4"
export const SPECIAL_NOTE_SMALL2 = ' to see engagement rings available for Christmas Delivery.'

export const SPECIAL_NOTE_BIG = SPECIAL_NOTE_SMALL
//export const SPECIAL_NOTE_BIG = "Order by Monday, April 19, 2021 for Mother's Day delivery. This delivery date overrides regular processing times noted below."

export const MSG_NO_SESSION1 = 'Site error. Please return to '
export const MSG_NO_SESSION2 = ', personalize, and add to cart again. If problem persists, please contact customer service. We’re sorry for the inconvenience.'
export const MSG_NOT_READY_ADD_TO_CART ='Please select RING SIZE in order to add product to the shopping bag'
export const MSG_NO_USER_DIAMOND ='Please provide all correct information for Customer Diamond'
export const PRICE_URL = '//test.thepersonalizedbest.com/bridal_getpriceNL/'
export const PRICE_URL_PROD = '//main.thepersonalizedbest.com/bridal_getpriceNL/'
export const CFG_URL = '//test.thepersonalizedbest.com/bridal_cfg2sku6/'
export const CFG_URL_PROD = '//main.thepersonalizedbest.com/bridal_cfg2sku6/'
export const ADD_TO_CART_URL = 'https://test.thepersonalizedbest.com/add_to_cartNL'
export const ADD_TO_CART_URL_PROD = 'https://main.thepersonalizedbest.com/add_to_cartNL'
export const OPTION_URL = '//static.thepersonalizedbest.com/nl/'
//export const DYNAMIC_OPTION_URL = '//bridalimages.thepersonalizedbest.com/bridal_getmimgNL/'
export const DYNAMIC_OPTION_URL = '//test.thepersonalizedbest.com/bridal_getmimgNL/'
export const ENGRAVING_URL = '//bridalimages.thepersonalizedbest.com/text.jpg'  //  t ,f
//export const DYNAMIC_OPTION_URL = '//bridalimages-master.thepersonalizedbest.com/bridal_getmimg/'
//export const ENGRAVING_URL = '//bridalimages-master.thepersonalizedbest.com/text.jpg'  //  t ,f
export const DYNAMIC_BAND_OPTION_URL ='//bridalimages.thepersonalizedbest.com/bridal_imageNL/'
//export const DYNAMIC_BAND_OPTION_URL ='//test.thepersonalizedbest.com/bridal_imageNL/'
export const DEFAULT_CFG = 'CFG12559000000000'
export const DEFAULT_K_SKU = '3UOEL02'
export const DEFAULT_K_SKU2 = '3UOEL0B'
export const DEFAULT_J_SKU = '1WTCK8V36A0XYTA'
export const DEFAULT_Z_SKU = '1DIF4GT7PVA0X32E'

export const DEFAULT_Z_QSKU = '20155466'
export const DEFAULT_KJ_QSKU = 'Neilbridalqsku'
export const DEFAULT_KJ_QSKU2 = 'Neilbridalsetqsku'

export const INITIAL_ZALES_IMG_URL ='//static.thepersonalizedbest.com/nl/init_nl.jpg'
export const INITIAL_KAY_IMG_URL ='//static.thepersonalizedbest.com/nl/init_nl.jpg'
export const INITIAL_KAY_IMG_URL2 ='//static.thepersonalizedbest.com/nl/init_nl.jpg'
export const ZALES_SKU_URL ='//test.thepersonalizedbest.com/bridal_zsku2sku6/?zsku='
export const ZALES_SKU_URL_PROD ='//main.thepersonalizedbest.com/bridal_zsku2sku6/?zsku='

export const START_OVER_STATE = {
  'active_view':1,
  fr:   "0",
  fb1:   "0",
  fb2:   "0",
  rs:  DEFAULT_STATE_VALUE,
  er:  "",
  eb1:  "",
  eb2:  "", 
}



// WEBPACK FOOTER //
// ./src/constants.js